import React from "react";
import { Navigate } from "react-router-dom";

const UpgradePlan = () => <Navigate to="/main/account#plans" replace />;

export default UpgradePlan;
